export default {"src":"/_next/static/media/seBankId.99a40278.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};